// @flow strict

import * as React from 'react';
import { HomeHero } from './HomeHero';

// import HeaderCta from '../../components/HeaderCta';
// import type { PropTypes } from '../../components/HeaderCta';
// import EmailSignUpCTA from './EmailSignUpCTA';

// type HomePropTypes = PropTypes & {
//   askForEmailOnly: boolean,
//   restrictedEmails: Array<string>,
//   restrictedEmailMessage: string,
//   sendGridApiKey: string,
// };

const Home = () => {
  // eslint-disable-next-line no-console
  // if (props.askForEmailOnly) {
  //   return <EmailSignUpCTA {...props} noBottomPadding />;
  // }
  return <HomeHero />;
};

export default Home;
